import { render, staticRenderFns } from "./TotalDepositBonus.vue?vue&type=template&id=2b1d262c"
import script from "./TotalDepositBonus.vue?vue&type=script&lang=js"
export * from "./TotalDepositBonus.vue?vue&type=script&lang=js"
import style0 from "./TotalDepositBonus.vue?vue&type=style&index=0&id=2b1d262c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports